// Task item variant tailored for the backlog/organize view.
import { memo } from 'react';
import TaskItem from '@/features/tasks/components/items/TaskItem';

/** @typedef {import('@/types').Task} Task */

/**
 * TaskItemOrganize - Optimized for the backlog and project structure on the Organize Page.
 * @param {Object} props
 * @param {Task} props.task - The task object.
 */
const TaskItemOrganize = (props) => {
  return <TaskItem {...props} view="organize" />;
};

export default memo(TaskItemOrganize);
